import React from "react";
import { Outlet, NavLink, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Sparkles, LayoutDashboard, FileText, GraduationCap, MessagesSquare, CalendarClock, Mail, LogOut, Wallet, Star, Share2, Compass } from "lucide-react";
import { Button } from "../components/ui/button";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/courses", label: "Courses", icon: GraduationCap },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessagesSquare },
  { to: "/admin/reviews", label: "Reviews", icon: Star },
  { to: "/admin/share-tools", label: "Share Tools", icon: Share2 },
  { to: "/admin/astrology-tools", label: "Astrology Tools", icon: Compass },
  { to: "/admin/consultations", label: "Consultations", icon: CalendarClock },
  { to: "/admin/enquiries", label: "Enquiries", icon: Mail },
  { to: "/admin/payments", label: "Payments", icon: Wallet },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  if (loading) return <div className="min-h-screen grid place-items-center text-foreground/60">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const doLogout = () => { logout(); nav("/admin/login"); };

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-background text-foreground flex">
      <aside className="w-64 shrink-0 border-r border-foreground/10 bg-[#0B1F3A] text-[#F5E8D8] p-5 flex flex-col">
        <div className="flex items-center gap-3 mb-10">
          <img src="/assets/logo-mono.png" alt="YourAstroHub" className="h-10 w-auto" />
          <div>
            <div className="font-serif text-lg">YourAstroHub</div>
            <div className="text-[0.6rem] uppercase tracking-[0.3em] text-[#AD974F]">Admin</div>
          </div>
        </div>
        <nav className="flex-1 space-y-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-colors ${isActive ? "bg-[#D4AF37] text-[#0B1F3A] font-semibold" : "text-[#F5E8D8]/70 hover:bg-[#0F284B]"}`}>
              <l.icon className="w-4 h-4" />{l.label}
            </NavLink>
          ))}
        </nav>
        <div className="pt-6 border-t border-[#D4AF37]/20">
          <div className="text-xs text-[#F5E8D8]/60 mb-1">Signed in as</div>
          <div className="text-sm truncate">{user.email}</div>
          <Button data-testid="admin-logout" onClick={doLogout} size="sm" variant="outline" className="w-full mt-3 rounded-full border-[#D4AF37]/40 bg-transparent hover:bg-[#D4AF37]/10 text-[#F5E8D8]">
            <LogOut className="w-3.5 h-3.5 mr-2" />Sign out
          </Button>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
